<div class="bg-heading-primary">
<div class="w-full flex justify-center items-center border-t border-border-1">
  <div class="w-full px-4 md:px-0 md:w-5/6">
    <!-- grid 2 col 60 40 -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div class="col-span-2 border-b md:border-b-0 md:border-r border-border-1 pt-20 pb-10 md:pb-20 md:pr-10">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div class="col-span-1 md:col-span-2">
            <h2 class="text-white text-xl font-semibold tracking-tight mb-6 md:mb-10">Nuestras oficinas</h2>

            <div class="flex flex-col gap-2 text-common-white">
              <span class="text-sm text-common-black">Calle 23 de Achumani, esquina Av. Alexander Nro 53</span>
              <p>
                <span>Lun-Vie 9:00AM - 5:00PM</span>
                <br>
              </p>
              <a href="https://wa.me/59162584781" target="_blank" class=" text-white relative underline-effect w-fit">
                <i class="fa-brands fa-whatsapp"></i>
                +591 - 62584781
              </a>
              <a href="mailto:tu@consultorio.biz" class=" text-white relative underline-effect w-fit">tu@consultorio.biz</a>
            </div>

            <!-- <div class="flex flex-col gap-2 text-common-white mt-6 md:mt-10">
              <span class="text-sm text-common-black">Operations - CANADA</span>
              <p>
                <span>Suite 452 4856 Boner Parge,</span>
                <br><span>Elviraton, CA 95623</span>
              </p>
            </div> -->

          </div>
          <div class="col-span-1">
            <h2 class="text-white text-xl font-semibold tracking-tight mb-6 md:mb-10">Mapa del sitio</h2>
            <ul class="flex flex-col gap-2 text-common-white">
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/">Inicio</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/about">Conócenos</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/advisors">Agenda con</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/resources">Recursos</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/events">Eventos</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a [routerLink]="['/news']">Noticias</a></li>
            </ul>
          </div>
          <div class="col-span-1">
            <h2 class="text-white text-xl font-semibold tracking-tight mb-6 md:mb-10">Agenda con</h2>
            <ul class="flex flex-col gap-2 text-common-white">
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/advisors/collaborator">Colabs</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/advisors/ies">Asesores</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/advisors/expert">Experts</a></li>
              <li class="hover:text-secondary hover:translate-x-1 transition delay-75 duration-500 ease-in-out cursor-pointer"><a routerLink="/suppliers">Proveedores</a></li>
             </ul>
          </div>
        </div>
      </div>
      <div class="col-span-1 pb-20 pt-0 md:pt-20 md:ml-10">
        <h2 class="text-white text-xl font-semibold tracking-tight mb-6 md:mb-10">
          <!-- Suscríbete a nuestros boletines -->
          No somos fans del spam (<i>y sabemos que tú tampoco</i>). Déjanos tu correo y te contactaremos sólo cuando tengamos algo que
          sí te interese.
        </h2>
        <form id="subscribe-form" (ngSubmit)="onSubmit()" class="relative">
          <span>
            <input 
              type="email" 
              placeholder="Correo electrónico" 
              class="text-white bg-white/10 border border-transparent focus-visible:border-secondary! transition duration-300 ease-in-out w-full"
              [(ngModel)]="email"
              name="email"
              required
            >
          </span>
          <button class="bg-transparent" type="submit">
            <i class="fa fa-paper-plane text-secondary! text-2xl"></i>
          </button>
        </form>
        @if (message()) {
          <div class="mt-4 font-heading" [ngClass]="{'text-secondary': !isError(), 'text-red-400': isError()}">
            {{ message() }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
<!-- footer socials -->
<div
  class="flex justify-center items-center bg-white/10 text-white"
>
  <div class="
    flex flex-col md:flex-row w-5/6
    gap-6
    p-6
    justify-center
    items-center
    md:justify-between
  ">
    <!-- copyright text -->
    <div class="copyright-text">
      <p class="text-common-white">© 2025 <a
          href="#"
          target="_blank"
          class="font-semibold hover:text-secondary"
        >Tú-Consultorio Empresarial</a> All right reserved.
      </p>
    </div>
  
    <!-- socials -->
    <div class="copyright-socails">
      <ul class="flex gap-4 items-center text-heading-primary">
        <ng-container *ngFor="let social of socials">
          <li class="bg-common-white rounded-full h-7 w-7 flex items-center justify-center hover:text-secondary hover:bg-heading-primary transition-colors">
            <a [href]="social.link" target="_blank">
              <i
                aria-hidden="true"
                [ngClass]="social.icon"
              ></i> </a>
          </li>
        </ng-container>  
      </ul>
    </div>
  
    <div class="flex gap-4 text-common-white items-center">
      <a class="hover:text-white" routerLink="/policy-privacy">Política de Privacidad</a>
      <!-- <span class="before:content-[''] w-1 h-1 bg-common-white rounded-full"></span>
      <a class="hover:text-white" routerLink="/terms-conditions">Terms &amp; conditions</a> -->
    </div>
  </div>
</div>
</div>